import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterToolbar = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  typeFilter,
  onTypeFilterChange,
  dateRange,
  onDateRangeChange,
  onClearFilters,
  selectedCount,
  onBulkDelete,
  onBulkExport
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'draft', label: 'Draft' },
    { value: 'completed', label: 'Completed' },
    { value: 'rendering', label: 'Rendering' },
    { value: 'error', label: 'Error' }
  ];

  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'title-cards', label: 'Title Cards' },
    { value: 'end-crawl', label: 'End Crawl' },
    { value: 'combined', label: 'Combined' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  const hasActiveFilters = searchQuery || statusFilter !== 'all' || typeFilter !== 'all' || dateRange !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Search and Filters Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4 mb-4">
        {/* Search */}
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search projects..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
            placeholder="Status"
            className="w-full sm:w-32"
          />
          
          <Select
            options={typeOptions}
            value={typeFilter}
            onChange={onTypeFilterChange}
            placeholder="Type"
            className="w-full sm:w-32"
          />
          
          <Select
            options={dateRangeOptions}
            value={dateRange}
            onChange={onDateRangeChange}
            placeholder="Date"
            className="w-full sm:w-32"
          />

          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              iconName="X"
              onClick={onClearFilters}
            >
              Clear
            </Button>
          )}
        </div>
      </div>
      {/* Bulk Actions Row */}
      {selectedCount > 0 && (
        <div className="flex items-center justify-between p-3 bg-primary/5 border border-primary/20 rounded-lg">
          <div className="flex items-center space-x-3">
            <Icon name="CheckSquare" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">
              {selectedCount} project{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>
          
          <div className="flex space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              onClick={onBulkExport}
            >
              Export Selected
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              onClick={onBulkDelete}
            >
              Delete Selected
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterToolbar;